<template>
  <step-block
    class="step-block--security"
    v-bind="$attrs"
    v-on="$listeners"
    :title="name"
    :short-description="shortDescription"
    :description="description"
    :description-expandable="!!description"
  >
    <figure slot="cover" v-if="photo">
      <img
        class="img-fluid"
        :src="photo"
      >
    </figure>
  </step-block>
</template>

<script>
  export default {
    name: 'SafetyTypeBlock',
    props: {
      id: {},
      name: String,
      photo: String,
      shortDescription: String,
      description: String,
    },
  };
</script>
